export const colors = {
  interactionPrimary: '#226cff',
  interactionPrimaryHover: '#1f61e5',
  interactionPrimaryPressed: '#1b56cc',
  interactionSecondary: '#226cff',
  interactionSecondaryHover: '#1f61e5',
  interactionSecondaryPressed: '#1b56cc',
  interactionSuccess: '#00843d',
  interactionSuccessHover: '#007737',
  interactionSuccessPressed: '#006a31',
  interactionNeutral: '#595959',
  interactionNeutralHover: '#696969',
  interactionNeutralPressed: '#7a7a7a',
  contentPrimary: '#222222',
  contentSecondary: '#595959',
  contentTertiary: '#c9c9c9',
  contentStateDisabled: '#c9c9c9',
  contentInversePrimary: '#ffffff',
  contentBrand: '#002873',
  contentAdditionalA: '#e5272d',
  contentAdditionalB: '#226cff',
  contentAdditionalC: '#226cff',
  contentAdditionalD: '#226cff',
  contentAdditionalE: '#226cff',
  borderPrimary: '#949494',
  borderSecondary: '#949494',
  borderSelection: '#7a7a7a',
  borderInverse: '#226cff',
  borderStateDisabled: '#e0e0e0',
  borderStateHover: '#858585',
  backgroundPrimary: '#ffffff',
  backgroundSecondary: '#ffffff',
  backgroundTertiary: '#ffffff',
  backgroundBrand: '#002873',
  backgroundBrandDark: '#0b2658',
  backgroundDark: '#383838',
  backgroundOverlay: 'rgba(34, 34, 34, 0.5)',
  backgroundStateSelected: '#ffffff',
  backgroundStateHover: '#ffffff',
  backgroundStateDisabled: '#e0e0e0',
  backgroundStateSelectedTransparent: '#ffffff',
  backgroundInteractionSecondaryTransparentLight: '#ffffff',
  backgroundInteractionSecondaryTransparentDark: '#ffffff',
  backgroundInteractionSecondaryTransparentWhite: 'rgba(255, 255, 255, 0.1)',
  backgroundInteractionSecondaryTransparentBlack: 'rgba(0, 0, 0, 0.1)',
  systemPositive: '#00843d',
  systemPositiveAlert: '#006b32',
  systemPositiveHover: '#007737',
  systemPositiveBackground: '#ffffff',
  systemPositiveBackgroundHover: '#ffffff',
  systemPositiveBackgroundPressed: '#ffffff',
  systemWarning: '#f06c00',
  systemWarningAlert: '#c25700',
  systemWarningHover: '#d86100',
  systemWarningBackground: '#ffffff',
  systemWarningBackgroundHover: '#ffffff',
  systemWarningBackgroundPressed: '#ffffff',
  systemError: '#cc0008',
  systemErrorAlert: '#a60006',
  systemErrorHover: '#b80007',
  systemErrorBackground: '#ffffff',
  systemErrorBackgroundHover: '#ffffff',
  systemErrorBackgroundPressed: '#ffffff',
  buttonPrimaryInfoColor: '#ffffff',
  buttonPrimarySuccessColor: '#ffffff',
  buttonPrimaryWarningColor: '#ffffff'
};